angular.module('wbDashboard')
.controller('InviteControllerAurea',
    ['$scope', '$window', '$uibModal', '$filter', '$timeout', '$q', 'User', 'Message', 'GoogleApi',
        'NgTableParams', 'Track', 'invitesResolve',
function ($scope, $window, $uibModal, $filter, $timeout, $q, User, Message, GoogleApi,
          NgTableParams, Track, invitesResolve) {

    $scope.pageData = {
        sending: false,
        errorMsg: null
    };
    $scope.forms = {};
    $scope.invite = {
        joined: null,
        referrals: {
            accepted: 0
        },
        link: "https://axosinvest.com/r/"
    };
    $scope.referralData = {};

    $scope.tabs = {
        active: 'invite',
        data: {
            "invite" : {label: 'Invite', value: 'invite'},
            "past" : {label: 'Sent', value: 'past'},
        }
    };

    var trackingDescription = "invite";
    if ($scope.welcome) {
        //controller is used for welcome invite screen as well, so needs to adjust tracking for that page
        trackingDescription = "welcome";
    }
    if (trackingDescription === "invite") {
        Track.send("View Invite Screen", trackingDescription, {});
    }

    $scope.$watch(User.getOverview, function(overview) {
        if (overview) {
            $scope.invite.link = "https://axosinvest.com/r/" + overview.referrals.client_referral_share_link;
            $scope.invite.linkOriginal = $scope.invite.link; //fake readonly for iOS
            $scope.invite.referrals = overview.referrals;
            $scope.full_name = overview.user.first_name + " " + overview.user.last_name;
        }
    });

    /**
     *
     * Get and format data for referral table
     *
     */
    $scope.$watch(function() { return User.getInvites(); }, function(inviteData) {
        if (!$scope.referralData.tableParams) {
            $scope.referralData.tableParams = new NgTableParams({
                count: 10,
                sorting: { date: "desc"}
            }, {
                counts: [],
                // determines the pager buttons (left set of buttons in demo)
                paginationMaxBlocks: 7,
                paginationMinBlocks: 0,
                dataset:null
            });
        }
        if (inviteData) {
            var joinedCount = 0;
            var dataSet = [];
            angular.forEach(inviteData.invites, function(referral) {
                //need to format date properly for not Chrome (YYYY-MM-DDTHH:MM:SS) (need the "T" seperator)
                if (referral.is_user) {joinedCount++;}

                var data = {
                    email: referral.email,
                    type: $filter('capitalize')(referral.alias_type),
                    date: new Date(referral.created_at.replace(" ","T")),
                    user_status: $filter('capitalize')(referral.user_status),
                };
                dataSet.push(data);
            });

            $scope.invite.joined = joinedCount;
            $scope.referralData.tableParams.settings({
                dataset : dataSet
            });
        }
    });

    /**
     *
     * Share stuff
     *
     */
    $scope.shareFacebook = function() {
        Track.send("Share to Facebook", trackingDescription, {});
        $window.open('http://www.facebook.com/sharer.php?u=' + $scope.invite.link + '?alias=facebook', 'sharer', 'toolbar=0,status=0,width=548,height=325');
    };
    $scope.shareTwitter = function() {
        Track.send("Share to Twitter", trackingDescription, {});
        var twitterShareText = "Check out @AxosInvest: an automated investment tool that's helping me build my financial goals. Use my invite to join today! " + $scope.invite.link +"?alias=twitter";
        $window.open('http://twitter.com/home?status='+ encodeURI(twitterShareText) +'%0A', 'sharer', 'toolbar=0,status=0,width=548,height=325');
    };

    /**
     *
     * Invite link stuff
     *
     */
    $scope.selectShare = function($event) {
        //highlight/select the invite link text on input clicked
        var element = $event.currentTarget;
        element.setSelectionRange(0, 9999);
    };
    $scope.resetInviteLink = function() {
        //invite link box isn't read only, it can be modified
        //in case invite link box is changed, set it back (needed due to readonly not working for copy on iOS)
        if ($scope.invite.link != $scope.invite.linkOriginal) {
            $scope.invite.link = $scope.invite.linkOriginal;
        }
    };
    $scope.copySuccess = function() {
        Track.send("Share by Link", trackingDescription, {});
        Message.set({
            "text" : "Invite link copied - now share with the world!",
            "type" : "success"
        });
    };
    $scope.copyError = function() {
        $scope.pageData.showShareLink = true;
        $timeout(function() {
            angular.element('.share-link:visible input').focus();
            angular.element('.share-link:visible input')[0].setSelectionRange(0, 100);
        }, 100);
        if ((/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream)
            || !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) //iOS chrome doesn't put iphone in userAgent
           ) {
            //intended if iPhone
        } else {
            Track.send("Share by Link (Copy Error)", trackingDescription, {});
            Message.set({
                "text": "Couldn't copy, link now selected, please press Ctrl/Cmd+C to copy.",
                "type": "warning"
            });
        }
    };


    /**
     *
     * Submitting emails stuff
     *
     */

    $scope.inviteGmail = function() {
        GoogleApi.initAuth().then(function(authResult) {
            if (authResult) {
                if (!authResult.error) {
                    // return GoogleApi.getPeople();
                    if ($scope.googleContacts) {
                        return $scope.googleContacts;
                    } else {
                        return GoogleApi.getContacts(authResult);
                    }
                } else {
                    if (authResult.error === "popup_closed_by_user") {
                        //do nothing
                    } else {
                        Message.set({
                            text: "Unable to find google contacts",
                            type: "warning"
                        });
                    }
                    throw false;
                }
            } else {
                throw authResult;
            }
        }).then(function(contacts) {
            $scope.googleContacts = contacts;

            var modalInstance = $uibModal.open({
                templateUrl: "google-email-list.tpl.html",
                scope: $scope,
                size: 'md',
                windowClass: 'invite-gmail-modal'
            });

            modalInstance.result.then(function () {
                //confirmed send all emails!
                var emails = [];
                angular.forEach($scope.invite.googleEmails, function(value) {
                    delete value.checked;
                    emails.push(value.email);
                });
                $scope.invite.googleEmails.length = 0;
                return $scope.sendEmailReferrals(emails, 'email');
            }).catch(angular.noop);

        }).catch(function(err) {
            if (err !== false) {
                Message.set({
                    text: "Unable to find google contacts",
                    type: "warning"
                });
            }
        });
    };
    $scope.$watch('googleContacts', function(googleContacts) {
        if (googleContacts) {
            $scope.invite.googleEmails = $filter('filter')(googleContacts, {checked: true});
        }
    }, true);
    $scope.toggleAllGmailContacts = function(toggle) {
        angular.forEach($scope.googleContacts, function(gc) {
            gc.checked = !!toggle;
        });
    };


    $scope.inviteSubmit = function(alias) {

        var emails = [];
        for (var i in $scope.invite.emails) {
            emails.push($scope.invite.emails[i].text);
        }

        $scope.sendEmailReferrals(emails, alias);

    };

    $scope.reinvite = function(referral) {
        if (referral.user_status.toLowerCase()==="expired" && referral.type.toLowerCase() === "email") {
            $scope.sendEmailReferrals([referral.email], 'email');
        }
    };

    $scope.sendEmailReferrals = function(emails, alias) {
        $scope.pageData.sending = true;
        $scope.pageData.errorMsg = null;

        var errors = [];
        var good = [];
        User.makeReferral({email:emails, alias:alias}).then(function (response) {
            angular.forEach(response.data, function (value, email) {
                //copy paste from legacy, horrible api response
                if ("error" in value) {
                    if (value.error.email && value.error.email[0]) {
                        if (value.error.email[0].indexOf("You have already invited") !== -1) {
                            errors.push(value.error.email[0]);
                        } else if (value.error.email[0].indexOf("to skip the waitlist") !== -1) {
                            errors.push(value.error.email[0]);
                        } else if (value.error.email[0].indexOf("greater than 40 characters") !== -1) {
                            errors.push(email + " is too long, must be 40 characters or less");
                        } else {
                            errors.push(email + " has already been invited.");
                        }
                    } else {
                        errors.push(email + " has already been invited.");
                    }
                } else {
                    Track.send("Input Email Referral", trackingDescription, {});

                    good.push(value);
                    angular.forEach($scope.invite.emails, function (emailItem, k) {
                        if (emailItem.text === email) {
                            $scope.invite.emails.splice(k, 1);
                        }
                    });
                }
            });
            if (errors.length) {
                $scope.pageData.errorMsg = errors.join("<br /><br />");
            }
            if (good.length) {
                return User.retrieveInvites(true);
			}
        }).then(function() {
            if (good.length) {
                Message.set({
                    text: "Your friends have been invited, thanks for spreading the word!",
                    type: "success"
                });
            }
        }).catch(function (response) {
            $scope.pageData.errorMsg = "Something went wrong, please try again later.";
        }).finally(function () {
            $scope.pageData.sending = false;
        });
    };

    var transitionDeregisterHook = $scope.$transitions.onSuccess({ to: "base.invite" }, function(trans) {
        if (trans.to().name !== trans.from().name) {
            // $scope.setGauge();
        }
    });
    $scope.$on('$destroy', function() {
        if (transitionDeregisterHook) {
            transitionDeregisterHook();
        }
    });
}]);
